// src/AuthHelperMethods.js

import decode from "jwt-decode";
import { authApiRequest } from "./authApiRequest";
let isLoading = true;
let hasError = false;
let data = {};

//const APIURL = process.env.REACT_APP_APIURL;
//const BASE_URL = "https://eqolinux.ngrok.app/";
//const BASE_URL = import.meta.env.VITE_DATA_API;

export default class AuthHelperMethods {
  // *** NEW: set up the auth-ready promise when the class is instantiated
  constructor() {
    console.log("Auth constructor running");
    this.onError = null; // add to constructor
    this._isLoading = true;
    this.authReady = new Promise((resolve) => {
      this._resolveAuthReady = resolve;
    });
    this._initAuth();
  }

  // *** NEW: validate the token on init, then resolve authReady
  _initAuth = async () => {
    console.log("_initAuth running, loggedIn:", this.loggedIn());
    try {
      if (!this.loggedIn()) {
        this.setToken("");
      }
    } finally {
      console.log("_initAuth finally block reached");
      this._isLoading = false;
      this._resolveAuthReady();
    }
  };

  // *** NEW: used by the private route to know if auth is still being confirmed
  isLoading = () => {
    return this._isLoading;
  };

  /*getUserType = () => {
    let usercode = decode(this.getToken()).user_type_code;
    return usercode;
  };
*/
  getUserType = () => {
    const token = this.getToken();
    if (!token) return false;
    let usercode = decode(token).user_type_code;
    return usercode;
  };

  getUserPersonId = () => {
    const token = this.getToken();
    if (!token) return false;
    let person_id = decode(token).user_person_id;
    return person_id;
  };

  getUserRoleIds = () => {
    const token = this.getToken();
    if (!token) return false;
    let role_id = decode(token).role_id;
    return role_id;
  };

  loggedIn = () => {
    const token = this.getToken();
    return !!token && !this.isTokenExpired(token);
  };

  isTokenExpired = (token) => {
    if (!token) return false;
    try {
      const decoded = decode(token);

      if (decoded.exp < Date.now() / 1000) {
        return true;
      } else return false;
    } catch (err) {
      return false;
    }
  };

  setToken = (idToken) => {
    localStorage.setItem("auth_token", idToken);
  };

  getToken = () => {
    return localStorage.getItem("auth_token");
  };

  getConfirm = () => {
    const token = this.getToken();
    if (!token) return false;
    let answer = decode(token);
    return answer;
  };

  getHeaders() {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.getToken()}`,
    };
    return headers;
  }

  api = async (endpoint, method, data, options = {}) => {
    return authApiRequest(
      {
        authReady: this.authReady,
        getToken: this.getToken,
        setToken: this.setToken,
        getOnError: () => this.onError,
      },
      endpoint,
      method,
      data,
      options,
    );
  };
}
